<template>
    <q-page class="q-pa-md">
        <!-- DIALOGO DE CONFIRMACION ELIMINAR BRIGADA-->
        <q-dialog v-model="dialogConfirmDatosBrigada" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar la brigada <strong>{{
                                item.brigada
                                    }}</strong>.?</span>
                        </div>

                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDeleteBrigadaDatos()" />
                    <q-btn label="Aceptar" color="primary" @click="DeleteItem()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOGO DE CONFIRMACION ELIMINAR BRIGADA ASIGANADA-->
        <q-dialog v-model="dialogConfirmBrigada" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar la brigada <strong>{{
                                itemBrigada.brigada
                                    }}</strong> con <strong>{{ itemBrigada.noPersonal
                                    }}</strong> de personal asignado.?</span>
                        </div>

                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al eliminar la brigada, el personal asignado quedará disponible para ser reasignado
                            a otra
                            brigada.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDeleteBrigada()" />
                    <q-btn label="Aceptar" color="primary" @click="DeleteItemBrigada()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOGO DE CONFIRMACION FINALIZAR BRIGADA ASIGANADA-->
        <q-dialog v-model="dialogConfirmBrigadaFinalizar" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de finalizar la brigada <strong>{{
                                itemBrigada.brigada
                                    }}</strong> con <strong>{{ itemBrigada.noPersonal
                                    }}</strong> de personal asignado.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al finalizar la brigada, solo el usuario administador podra ver la información.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDeleteBrigada()" />
                    <q-btn label="Aceptar" color="primary" @click="FinalizarItemBrigada()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOGO DE CONFIRMACION ELIMINAR PERSONAL -->
        <q-dialog v-model="dialogConfirmPersonal" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar el personal <strong>{{
                                itemPersonal.nombre
                                    }}</strong> de la brigada.?</span>
                        </div>

                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al quitar el personal estara disponible para ser asignado a otra brigada.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDeletePersonal()" />
                    <q-btn label="Aceptar" color="primary" @click="desAsignar()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOGO DE CONFIRMACION ELIMINAR SEDE-->
        <q-dialog v-model="dialogConfirmSede" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar la Sede <strong>{{
                                itemSede.sede
                                    }}</strong> de la brigada.?</span>
                        </div>

                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p>
                        <br />
                        <p class="">Al quitar la sede estara disponible para ser asignado a otra brigada.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarDeleteSede()" />
                    <q-btn label="Aceptar" color="primary" @click="desAsignarSede()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- DIALOG BRIGADAS -->
        <q-dialog v-model="dialogBrigadas" persistent>
            <q-card style="width: 700px; max-width: 80vw;background: #f8fcff">
                <q-bar class="bg-primary text-white">
                    <q-icon name="mdi-bank" />
                    <div>Brigadas</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <q-form class="q-gutter-md">
                        <q-table :loading="loading" dense :data="dataListTodasBrigadas" :columns="columns">
                            <template v-slot:loading>
                                <q-inner-loading showing color="primary" />
                            </template>
                            <template v-slot:top>
                                <q-toolbar-title class="row col q-pb-sm">
                                    Brigada
                                    <q-space />
                                    <q-btn v-if="template == false" push round icon="mdi-plus" @click="crearItem()" />
                                    <q-btn v-if="template == true" push round icon="mdi-minus" class="q-mr-sm"
                                        @click="cancelar" />
                                    <q-btn v-if="template == true && item._id == ''" color="primary" push round
                                        icon="mdi-content-save" @click="PostItem()" />
                                </q-toolbar-title>

                                <template class="row " v-if="template == true">
                                    <div class="col-12 q-mb-md">
                                        <q-input dense filled v-model="item.brigada" label="Nombre de la Brigada" />
                                    </div>
                                </template>
                            </template>
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn v-if="props.row.estatus == 'Vigente'" size="md" style="color:#CC003D"
                                            rounded flat dense @click="eliminarItem(props.row)" icon="mdi-delete">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">Eliminar</q-tooltip>
                                        </q-btn>

                                    </q-td>
                                    <q-td key="brigada" :props="props">{{ props.row.brigada }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>

        <!-- DIALOG TIPO DE UNIDADES -->
        <q-dialog v-model="dialogAsignarBrigadas" persistent>
            <q-card style="width: 700px; max-width: 80vw;background: #f8fcff">
                <q-bar class="bg-primary text-white">
                    <q-icon name="mdi-bank" />
                    <div>Asignar Brigadas</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <q-form class="q-gutter-md">
                        <q-table row-key="_id" selection="multiple" :selected.sync="selectedPersonal"
                            :loading="loadingPersonal" dense :data="dataPersonal" :columns="columnsPersonal">
                            <template v-slot:loading>
                                <q-inner-loading showing color="primary" />
                            </template>
                            <template v-slot:top>
                                <q-toolbar-title class="row col q-pb-sm">
                                    Brigada
                                    <q-space />

                                    <q-btn color="primary" push round icon="mdi-content-save" @click="PostAsignar()" />
                                </q-toolbar-title>

                                <div class="col-12 q-mb-md">
                                    <q-select v-model="item" full-width label="Nombre de la Brigada" :options="dataList"
                                        dense filled option-label="brigada">
                                        <template v-slot:no-option>
                                            <q-item>
                                                <q-item-section class="text-grey">
                                                    Sin Datos
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-12 q-mb-md">

                                    <q-select v-model="selectedSede" multiple full-width label="Nombre de la Sede"
                                        :options="dataSedes" dense filled use-chips stack-label option-label="sede">
                                        <template v-slot:no-option>
                                            <q-item>
                                                <q-item-section class="text-grey">
                                                    Sin Datos
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                            </template>

                        </q-table>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogPersonalAsignado" persistent>
            <q-card style="width: 700px; max-width: 80vw;background: #f8fcff">
                <q-bar class="bg-primary text-white">
                    <q-icon name="mdi-bank" />
                    <div>Personal Asignado</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <q-form class="q-gutter-md">
                        <q-table row-key="_id" :loading="loadingPersonalAsignado" dense :data="dataPersonalAsignado"
                            :columns="columnsPersonalAsignado">
                            <template v-slot:loading>
                                <q-inner-loading showing color="primary" />
                            </template>
                            <template v-slot:top>
                                <q-toolbar-title class="row col q-pb-sm">
                                    Asignar Nuevo Personal
                                    <q-space />
                                    <q-btn v-if="templateP == false" push round icon="mdi-plus"
                                        @click="agregarPersonal()" />
                                    <q-btn v-if="templateP == true" push round icon="mdi-minus" class="q-mr-sm"
                                        @click="cancelarPersonal()" />
                                    <q-btn v-if="templateP == true && item._id == ''" color="primary" push round
                                        icon="mdi-content-save" @click="PostPersonalBrigada()" />
                                </q-toolbar-title>

                                <template class="row" v-if="templateP == true">
                                    <div class="col-12 q-mb-md">
                                        <q-select v-model="itemPersonal" full-width label="Nombre del Personal"
                                            :options="dataPersonal" dense filled option-label="nombre">
                                            <template v-slot:no-option>
                                                <q-item>
                                                    <q-item-section class="text-grey">
                                                        Sin Datos
                                                    </q-item-section>
                                                </q-item>
                                            </template>
                                        </q-select>
                                    </div>
                                </template>
                            </template>

                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td key="nombre" :props="props">{{ props.row.nombre }}</q-td>
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red" rounded flat dense
                                            @click="eliminarPersonal(props.row)" icon="mdi-delete">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">Quitar Personal</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogSedesAsignadas" persistent>
            <q-card style="width: 700px; max-width: 80vw;background: #f8fcff">
                <q-bar class="bg-primary text-white">
                    <q-icon name="mdi-bank" />
                    <div>Sedes Asignadas</div>
                    <q-space />
                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>
                <q-card-section>
                    <q-form class="q-gutter-md">
                        <q-table row-key="_id" :loading="loadingSedesAsignado" dense :data="dataSedesAsignado"
                            :columns="columnsSedesAsignado">
                            <template v-slot:loading>
                                <q-inner-loading showing color="primary" />
                            </template>
                            <template v-slot:top>
                                <q-toolbar-title class="row col q-pb-sm">
                                    Asignar Nueva Sede
                                    <q-space />
                                    <q-btn v-if="templateS == false" push round icon="mdi-plus"
                                        @click="agregarSede()" />
                                    <q-btn v-if="templateS == true" push round icon="mdi-minus" class="q-mr-sm"
                                        @click="cancelarSede()" />
                                    <q-btn v-if="templateS == true && item._id == ''" color="primary" push round
                                        icon="mdi-content-save" @click="PostSedeBrigada()" />
                                </q-toolbar-title>

                                <template class="row" v-if="templateS == true">
                                    <div class="col-12 q-mb-md">
                                        <q-select v-model="itemAsignSede" full-width label="Nombre de la Sede"
                                            :options="dataSedes" dense filled option-label="sede">
                                            <template v-slot:no-option>
                                                <q-item>
                                                    <q-item-section class="text-grey">
                                                        Sin Datos
                                                    </q-item-section>
                                                </q-item>
                                            </template>
                                        </q-select>
                                    </div>
                                </template>
                            </template>
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td key="sede" :props="props">{{ props.row.sede }}</q-td>
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red" rounded flat dense @click="eliminarSede(props.row)"
                                            icon="mdi-delete">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">Quitar Sede</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-form>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-col-gutter-md q-mt-sm">
            <div class="col-12 col-md-12 ">
                <q-table :loading="loadingBrigada" title="Treats" style="height: 100%;" :filter="filterBrigadas"
                    :data="dataBrigadas" :columns="columnsBrigada" row-key="_id">
                    <template v-slot:loading>
                        <q-inner-loading showing color="primary" />
                    </template>
                    <template v-slot:top>
                        <div class="text-h5">Brigadas</div>
                        <q-space />
                        <q-btn color="primary" icon="mdi-plus" label="NUEVA BRIGADA"
                            @click="abrirDialogNuevaBrigada()" />
                        <q-btn color="primary" icon="mdi-plus" class="q-ml-md" label="ASIGNAR BRIGADA"
                            @click="abrirDialogAsignarBrigada()" />
                        <q-btn round color="primary" icon="mdi-refresh" class="q-ml-md"
                            @click="GetBrigadasAsignadas()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props">
                            <q-td key="brigada" :props="props">{{ props.row.brigada }}</q-td>
                            <q-td key="fecha_creacion" :props="props">{{ props.row.fecha_creacion }}</q-td>
                            <q-td key="noPersonal" :props="props">{{ props.row.noPersonal }}</q-td>
                            <q-td key="noSedes" :props="props">{{ props.row.noSedes }}</q-td>
                            <q-td auto-width key="acciones">
                                <q-btn v-if="props.row.estatus == 'Vigente'" size="md" color="blue" rounded flat dense
                                    @click="finalizarBrigada(props.row)" icon="mdi-lock">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Finalizar Brigada</q-tooltip>
                                </q-btn>
                                <q-btn v-if="props.row.estatus == 'Vigente'" size="md" color="red" rounded flat dense
                                    @click="eliminarBrigada(props.row)" icon="mdi-delete">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Eliminar Brigada</q-tooltip>
                                </q-btn>
                                <q-btn size="md" color="green" rounded flat dense @click="VerSedes(props.row)"
                                    icon="mdi-map-marker-multiple">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Ver Sedes</q-tooltip>
                                </q-btn>
                                <q-btn size="md" color="primary" rounded flat dense @click="VerPersonal(props.row)"
                                    icon="mdi-account-group">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Ver Personal</q-tooltip>
                                </q-btn>
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>

</template>
<script>
import { format } from 'date-fns';
import { date, QSpinnerFacebook } from 'quasar'
import moment from 'moment';
import axios from "axios";
import * as XLSX from 'xlsx';
export default {

    data() {
        return {
            filterBrigadas: '',
            dataBrigadas: [],
            columnsBrigada: [
                { name: 'brigada', align: 'center', label: 'Brigada', field: 'brigada', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'fecha_creacion', align: 'center', label: 'Fecha de Asignación', field: 'fecha_creacion', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'noPersonal', align: 'center', label: 'Num. Personal Asignado', field: 'noPersonal', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'noSedes', align: 'center', label: 'Num. Sedes Asignado', field: 'noSedes', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            loadingBrigada: false,

            loading: false,
            dataList: [],
            columns: [
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'brigada', align: 'center', label: 'Brigada', field: 'brigada', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            template: false,
            item: {
                _id: '',
                brigada: '',
                usuario_creador: '',
                fecha_creacion: '',
                estatus: ''
            },
            dialogBrigadas: false,


            columnsPersonal: [
                { name: 'nombre', align: 'center', label: 'Nombre', field: 'nombre', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            loadingPersonal: false,
            selectedPersonal: [],
            dialogAsignarBrigadas: false,

            itemSede: {
                sede: '',
            },
            selectedSede: [],

            itemAsignar: {
                _id: '',
                _id_brigada: '',
                _id_personal: '',
                _id_sede: '',
                usuario_creador: '',
                fecha_creacion: '',
                estatus: 'Vigente'
            },

            loadingPersonalAsignado: false,
            dataPersonalAsignado: [],
            columnsPersonalAsignado: [
                { name: 'nombre', align: 'center', label: 'Nombre', field: 'nombre', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            dialogPersonalAsignado: false,
            _id_brigada_eliminar: '',

            itemBrigada: {
                brigada: '',
                noPersonal: 0
            },
            dialogConfirmBrigada: false,

            itemPersonal: {
                nombre: ''
            },
            dialogConfirmPersonal: false,

            columnsSedesAsignado: [
                { name: 'sede', align: 'center', label: 'Sede', field: 'sede', sortable: true, classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
                { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', classes: 'bg-grey-2 ellipsis text-center', headerClasses: 'bg-primary text-white text-center' },
            ],
            dataSedesAsignado: [],
            loadingSedesAsignado: false,
            dialogSedesAsignadas: false,

            dialogConfirmSede: false,
            itemSede: { sede: '' },
            dataListTodasBrigadas: [],

            dialogConfirmDatosBrigada: false,
            dialogConfirmBrigadaFinalizar: false,

            templateP: false,
            templateS: false,
            itemAsignSede: { sede: '' },
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario
        },
        dataSedes() {
            return this.$store.state.dataSedesStore
        },
        dataPersonal() {
            return this.$store.state.dataPersonalStore
        },

    },
    created() {
        this.GetSedes();
        this.GetBrigadas();
        this.GetPersonal();
        this.GetBrigadasAsignadas();
    },
    methods: {
        cancelarDeleteBrigadaDatos() {
            this.dialogConfirmBrigadaFinalizar = false
            this.item = {
                brigada: ''
            }
        },

        eliminarItem(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.dialogConfirmDatosBrigada = true
            this.item = item
        },
        cancelarDeleteSede() {
            this.dialogSedesAsignadas = false
            this.dialogConfirmSede = false
            this.itemSede = {
                sede: ''
            }
        },

        async desAsignarSede() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Quitando Sede. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/QuitarSede/config_inventarios/' + this._id_brigada_eliminar + '/' + this.itemSede._id,)
                this._id_brigada_eliminar = ''
                this.cancelarDeleteSede();
                this.GetBrigadasAsignadas();
                this.$q.loading.hide()
                this.$q.notify({ position: 'top-right', type: 'positive', message: `La sede se ha eliminado correctamente.` })

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },

        async DeleteItemBrigada() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Eliminando Brigada. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/DeleteBrigadasAsignada/config_inventarios/' + this.itemBrigada._id,)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Brigada eliminado correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarDeleteBrigada();
                await this.GetBrigadasAsignadas();

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },

        cancelarDeleteBrigada() {
            this.itemBrigada = {
                brigada: '',
                noPersonal: 0
            }
            this.dialogConfirmBrigada = false
        },
        eliminarBrigada(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            console.log(item)
            this.itemBrigada = item
            this.dialogConfirmBrigada = true
        },
        eliminarPersonal(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.itemPersonal = item
            this.dialogConfirmPersonal = true

        },

        eliminarSede(item) {

            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.itemSede = item
            this.dialogConfirmSede = true

        },
        cancelarDeletePersonal() {
            this.dialogPersonalAsignado = false
            this.dialogConfirmPersonal = false
            this.itemPersonal = {
                nombre: ''
            }
        },
        async desAsignar() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Quitando Personal. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/QuitarPersonal/config_inventarios/' + this._id_brigada_eliminar + '/' + this.itemPersonal._id,)
                this._id_brigada_eliminar = ''
                this.cancelarDeletePersonal();
                this.GetBrigadasAsignadas();
                this.$q.loading.hide()
                this.$q.notify({ position: 'top-right', type: 'positive', message: `El personal se ha eliminado correctamente.` })

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async VerPersonal(item) {
            this.loadingPersonalAsignado = true
            try {
                let respuesa = await axios.get('Configuracion/GetPersonalAsignada/config_inventarios/' + item._id)
                console.log(respuesa)
                this._id_brigada_eliminar = item._id
                this.loadingPersonalAsignado = false
                this.dataPersonalAsignado = respuesa.data
                this.dialogPersonalAsignado = true
            } catch (error) {
                this.loadingPersonalAsignado = false
                console.log(error)
            }
        },
        async VerSedes(item) {
            this.loadingSedesAsignado = true
            try {
                let respuesa = await axios.get('Configuracion/GetSedesAsignada/' + this.usuarioStore.baseDatos + '/' + item._id)
                console.log(respuesa)
                this._id_brigada_eliminar = item._id
                this.loadingSedesAsignado = false
                this.dataSedesAsignado = respuesa.data
                this.dialogSedesAsignadas = true
            } catch (error) {
                this.loadingSedesAsignado = false
                console.log(error)
            }
        },
        async GetBrigadasAsignadas() {
            this.loadingBrigada = true
            try {
                let respuesa = await axios.get('Configuracion/GetBrigadasAsignadas/config_inventarios')
                console.log(respuesa)
                this.loadingBrigada = false
                this.dataBrigadas = respuesa.data
            } catch (error) {
                this.loadingBrigada = false
                console.log(error)
            }
        },
        async PostAsignar() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.item.brigada == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Seleccione el nombre de la Brigada.' })
                return;
            }
            if (this.selectedSede.length == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Seleccione al menos una sede.' })
                return;
            }
            if (this.selectedPersonal.length == 0) {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Seleccione al menos un personal' })
                return;
            }

            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");

            let listaSede = []
            let listaPersonal = []
            for (let a of this.selectedPersonal) {
                listaPersonal.push(a._id)
            }
            for (let a of this.selectedSede) {
                listaSede.push(a._id)
            }

            // for (let a of this.selectedPersonal) {
            let objeto = {
                _id: '',
                _id_brigada: this.item._id,
                personas: listaPersonal,
                sedes: listaSede,
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: fechaC,
                estatus: 'Vigente',
                base_datos: this.usuarioStore.baseDatos
            }
            // lista.push(objeto)
            // }
            console.log(objeto)
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Asigando Datos. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostAsignarBrigadas/config_inventarios', objeto)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()

                this.cancelarAsignar();
                await this.GetPersonal();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        cancelarAsignar() {
            this.selectedSede = []
            this.item = {
                _id: '',
                brigada: '',
                usuario_creador: '',
                fecha_creacion: '',
                estatus: ''
            }
            this.selectedPersonal = []

        },
        async GetSedes() {
            try {
                let respuesa = await axios.get('Configuracion/GetSedes/' + this.usuarioStore.baseDatos)
                console.log(respuesa)
                this.$store.state.dataSedesStore = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async abrirDialogAsignarBrigada() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.dialogAsignarBrigadas = true

            await this.GetPersonal();
            await this.GetSedes();
            await this.GetBrigadas();


            this.itemAsignar = {
                _id: '',
                _id_brigada: '',
                _id_personal: '',
                _id_sede: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },
        abrirDialogNuevaBrigada() {
            this.GetBrigadasTodos();
            this.dialogBrigadas = true
            this.item = {
                _id: '',
                brigada: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },
        async crearItem() {
            this.template = true
        },
        async PostItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.item.brigada == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre de la brigada.' })
                return;
            }

            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");
            this.item.fecha_creacion = fechaC

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Guardando Brigada. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostBrigadas/config_inventarios', this.item)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarDelete();
                await this.GetBrigadasTodos();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async DeleteItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Eliminando Brigada. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/DeleteBrigadas/config_inventarios/' + this.item._id,)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Brigada eliminado correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarDelete();
                await this.GetBrigadasTodos();

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async GetBrigadas() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetBrigadas/config_inventarios')
                console.log(respuesa)
                this.loading = false
                this.dataList = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async GetBrigadasTodos() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetBrigadasTodos/config_inventarios')
                console.log(respuesa)
                this.loading = false
                this.dataListTodasBrigadas = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        cancelar() {
            this.template = false
            this.item = {
                _id: '',
                brigada: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
        },
        cancelarDelete() {
            this.item = {
                _id: '',
                brigada: '',
                usuario_creador: this.usuarioStore.email,
                fecha_creacion: '',
                estatus: 'Vigente'
            }
            this.dialogConfirmDatosBrigada = false
        },
        async GetPersonal() {
            this.loading = true
            try {
                let respuesa = await axios.get('Configuracion/GetPersonal/config_inventarios')
                console.log(respuesa)
                this.loading = false
                this.$store.state.dataPersonalStore = respuesa.data
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        finalizarBrigada(item) {
            this.itemBrigada = item
            this.dialogConfirmBrigadaFinalizar = true
        },
        async FinalizarItemBrigada() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Finalizando Brigada. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/FinalizarBrigadasAsignada/config_inventarios/' + this.itemBrigada._id,)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Brigada finalizada correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarFinalizarBrigada();
                await this.GetBrigadasAsignadas();

            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        cancelarFinalizarBrigada() {
            this.itemBrigada = {
                brigada: '',
                noPersonal: 0
            }
            this.dialogConfirmBrigadaFinalizar = false
        },

        agregarPersonal() {
            this.templateP = true
        },
        cancelarPersonal() {
            this.templateP = false
            this.itemPersonal = {
                nombre: '',
            }
        },
        async PostPersonalBrigada() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.itemPersonal.nombre == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Seleccione el nombre del Personal.' })
                return;
            }
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Asignando personal. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostPersonalBrigada/' + this.usuarioStore.baseDatos + '/' + this._id_brigada_eliminar + '/' + this.itemPersonal._id)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarPersonal();
                this.dialogPersonalAsignado = false
                await this.GetBrigadasAsignadas();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },

        agregarSede() {
            this.templateS = true
        },
        cancelarSede() {
            this.templateS = false
            this.itemAsignSede = {
                sede: '',
            }
        },
        async PostSedeBrigada() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.itemAsignSede.sede == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Seleccione el nombre de la sede.' })
                return;
            }
            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Asignando sede. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Configuracion/PostPersonalSede/' + this.usuarioStore.baseDatos + '/' + this._id_brigada_eliminar + '/' + this.itemAsignSede._id)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                this.cancelarSede();
                this.dialogSedesAsignadas = false
                await this.GetBrigadasAsignadas();
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        }


    }
}
</script>
<style>
.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>